import { SystemStyleObject } from '@chakra-ui/react';

interface ButtonWithActiveStateSxProps {
  root: SystemStyleObject;
}

export const buttonWithActiveStateSx: (
  isActive?: boolean
) => ButtonWithActiveStateSxProps = (isActive) => ({
  root: {
    display: 'flex',
    position: 'relative',
    gridArea: 'repeat',
    '&::after': {
      content: '""',
      transition: 'opacity 0.2s',
      opacity: isActive ? 1 : 0,
      position: 'absolute',
      width: 1,
      height: 1,
      bg: 'B.80',
      borderRadius: '50%',
      top: 6,
      left: '50%',
      transform: 'translate(-50%, 0px)',
    },
    _hover: {
      color: 'M.70',
    },
    transition: 'color 0.2s',
    color: isActive ? 'M.70' : 'M.60',
  },
});
